import CommonAPI from './CommonAPI.js';
import Auth from './Auth.js'

import Logger from './Logger.js'
import CommonUtil from './CommonUtil.js'


export default {
  test() {
    Logger.debug(Auth.getToken())
  },

  // Authentication methods moved to AuthService
  // Use AuthService.requestCode() and AuthService.confirmCode() instead

  
  getCandidateInfo(registerHash, func_ok, func_error) {
    if (!func_error) func_error = this._common_error

    return CommonAPI.instance().get(
      `/api/nominee/public/candidates/${registerHash}`,
      {})
      .then(res => func_ok(res.data))
      .catch((err) => func_error(err))
  },

  getMyRecommendations(func_ok, func_error) {
    if (!func_error) func_error = this._common_error

    return CommonAPI.instance().get(
      '/api/nominee/elector/my-recommendations',
      {
        headers: Auth.headers()
      })
      .then(res => func_ok(res.data))
      .catch((err) => func_error(err))
  },


  // Candidate info is now fetched via getCandidateInfo (public endpoint)

  recommend(registerHash, func_ok, func_error) {
    if (!func_error) func_error = this._common_error

    return CommonAPI.instance().post(
      `/api/nominee/elector/candidates/${registerHash}/recommend`,
      {},
      {
        headers: Auth.headers()
      })
      .then(res => func_ok(res.data))
      .catch((err) => func_error(err))
  },


    // My info would be available from auth token response
    // No specific API endpoint for this in the new documentation

    getTopicStatus(topicHash, func_ok, func_error) {
        if (!func_error) func_error = this._common_error

        return CommonAPI.instance().get(
            `/api/nominee/public/topics/${topicHash}/status`,
            {})
            .then(res => func_ok(res.data))
            .catch((err) => func_error(err))
    },

    submitCandidate(registerHash, func_ok, func_error) {
        if (!func_error) func_error = this._common_error

        return CommonAPI.instance().post(
            `/api/nominee/elector/candidates/${registerHash}/submit`,
            {},
            {
                headers: Auth.headers()
            })
            .then(res => func_ok(res.data))
            .catch((err) => func_error(err))
    },


    _common_error(err) {
        Logger.debug("error" + err)
        alert(CommonUtil.extractErrorMessage(err))
      },
      
}